import "./Cart.module.css";
import Header from "@/reusable_sections/Header";
import CartItems from "./sections/CartItems";
import OrderSummary from "./sections/OrderSummary";
import Footer from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <Header />
      <CartItems />
      <Footer />
    </div>;
}